import $ from 'jquery';
import 'bootstrap';

import typewriter from './lib/theme/typewritter';
import menuItem from './lib/theme/menuItem';
import heroScroll from './lib/theme/heroScroll';
import blockManifest from './lib/theme/block-manifest';
import scrollToDiv from './lib/function/scroll-to-div';
import contentMenuSlider from './lib/theme/_content-menu-slider';
import iFrameModal from './lib/function/video';

import themeSectorsSlider from './lib/theme/_sectorsSlider';
import themeContactBar from './lib/theme/_contact-bar';
import themeContentMenuButton from './lib/theme/_content-menu-button';
import themeHeader from './lib/theme/_header';
import themeMap from './lib/theme/_locationMap';

import headlineScrolle from './lib/theme/_headline-scroll';
import themePhotoWallslider from './lib/theme/_photoWallSlider';
import themeSelect from './lib/theme/_formSelect';
import readmore from './lib/theme/_readmore';
import datePicker from './lib/function/datepicker';
import scrollToTop from './lib/function/_scroll-to-top';
import scrollTo from './lib/theme/_scroll-to-top';
import boxWall from '../../gutenberg/lib/block-box-wall/index';
import imageContainerOversize from './lib/theme/_imgContainerOversize';
import contactModal from './lib/theme/_contact-modal';
import table from './lib/theme/_table.js';

$(document).ready(function () {
  menuItem();
  heroScroll();
  typewriter.init();
  themeSectorsSlider.init();
  themeContactBar.init();
  themeContentMenuButton.init();
  themeHeader.init();
  themeMap.init();
  headlineScrolle.init();

  themePhotoWallslider.init();
  themeSelect.init();
  datePicker();
  blockManifest();
  scrollToDiv();
  contentMenuSlider.init();
  readmore();
  scrollToTop.init();
  scrollTo.init();

  boxWall.init();
  imageContainerOversize.init();
  contactModal();
  table.init();
  iFrameModal('.content-section [data-bs-target]', 'data-bs-target');

  const contactOverlay = $('#contact-overlay');
  const contentMenu = $('.content-menu');

  $('[href="#contact-sidebar"]').on('click', function (e) {
    e.preventDefault();
    contactOverlay.toggleClass('is-open');
    $('.contact-overlay__button').toggleClass('is-open');
  });

  $('.contact-overlay__button').on('click', function () {
    contactOverlay.toggleClass('is-open');
    $('.contact-overlay__button').toggleClass('is-open');
  });

  $('.content-menu-button').on('click', function () {
    contentMenu.addClass('content-menu--open');
  });

  $('.content-menu__close').on('click', function () {
    contentMenu.removeClass('content-menu--open');
  });

  contentMenu.mouseleave(function() {
    contentMenu.removeClass('content-menu--open');
  });

  if(document.querySelector('.upload-area input')) {
    document.querySelector('.upload-area input').onchange = function () {
      var thefile = document.querySelector('.upload-area input');
      document.querySelector('.upload-area button').innerHTML = thefile.value.replace(/C:\\fakepath\\/i, '');
    };
  }

  $('.contact-modal__screen-1-box_button').on('click', function (e) {
    e.preventDefault();
    $(this).next().slideToggle();
    $(this).toggleClass('is-open');

  });

});

var lastScrollTop = 0, delta = 5, isScroll = 'down';
let headlineName = '';

function addClassOnScroll() {
  var windowTop = $(window).scrollTop();
  $('h2[id]').each(function (index, elem) {

    let offsetTop = $(elem).offset().top;
    let outerHeight = $(this).outerHeight(true);
    let headerHeight = $('.header').height();

    if (windowTop > (offsetTop - (headerHeight * 2)) && windowTop < (offsetTop + outerHeight)) {
      if (headlineName == elem.attributes[0].nodeValue) {
        return;
      }
      headlineName = elem.attributes[0].nodeValue;

      if (Math.abs(lastScrollTop - windowTop) >= delta) {
        if (windowTop > lastScrollTop) {
          $('.content-menu .swiper-button-next').trigger('click');
        } else {
          $('.content-menu .swiper-button-prev').trigger('click');
        }
        lastScrollTop = windowTop;
      }

      const elemId = $(elem).attr('id');
      $('.content-menu li.active').removeClass('active');
      $('.content-menu a[href=\'#' + elemId + '\']').parent().addClass('active');
    }
  });
};

addClassOnScroll();

$(window).scroll(function () {
  addClassOnScroll()
});

let toggleMenu = false;
$('.navbar-toggler').click(function () {

  if (toggleMenu == false) {
    $('.header__top').addClass('has-shadow');
    setTimeout(function () {
      toggleMenu = true;
    }, 500);
  }

  if (toggleMenu == true) {
    setTimeout(function () {
      $('.header__top').removeClass('has-shadow');
    }, 700);
    toggleMenu = false;
  }
});

$(window).resize(function () {
  let slideBg = $('.block-swiper__bg');
  slideBg.css('height', slideBg.width() + 'px');

  if ($(window).width() > 768) {
    $('#navbarNavDropdown').removeClass('show');
    $('.navbar-toggler').attr('aria-expanded', 'false');
    $('.nav-item').removeClass('is-active');
    $('.header .toggle-dropdown').removeClass('is-open');
    $('.dropdown-menu').attr('style', '');
    $('.dropdown ul').attr('style', '');
    $('#manifest-complete').attr('style', '');
    $('[aria-controls="manifest-complete"]').html('Alles anzeigen');
    $('#manifest-complete-accordion').attr('style', '');
  }
});
